import Card from '@/components/Card';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { Container as CardContainer } from '@/components/Card/styles';
import { Button } from '@/components/Button';

export const TraceCard = styled(Card)`
  max-width: 100%;
`;

export const IpStack = styled(Stack)<{ $isSm: boolean }>`
  flex-direction: ${({ $isSm }) => ($isSm ? 'column' : 'row')};

  gap: 16px;
  width: 100%;
`;

export const HopCard = styled(CardContainer, {
  shouldForwardProp: (prop) => prop !== '$expanded',
})<{ $expanded: boolean }>`
  display: flex;
  width: 100%;
  gap: 8px;

  flex-direction: ${({ $expanded }) => ($expanded ? 'column' : 'row')};
  align-items: ${({ $expanded }) => ($expanded ? 'stretch' : 'center')};
`;

export const ExpandButton = styled(IconButton)<{
  $expanded: boolean;
  $isSm: boolean;
}>`
  margin-left: auto;
  transition: ${({ theme }) =>
    theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    })};

  ${({ $expanded }) =>
    $expanded
      ? `      
        transform: rotate(180deg);
        align-self: flex-end;
        margin-top: 16px;
        margin-left: 0;
      `
      : ` 
        align-self: center;
        margin-top: 0;
        margin-left: auto;
      `}
  flex-shrink: 0;
  display: ${({ $isSm }) => ($isSm ? 'none' : 'flex')};
`;

export const HopStackColumn = styled(Stack)`
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
  }

  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;
`;

export const HopStackRow = styled(Stack)<{ $expanded: boolean }>`
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
  }

  flex-direction: row;
  width: 100%;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  flex-wrap: nowrap;
  padding: 20px 0;
`;

export const TracerouteButton = styled(Button)`
  min-width: 220px;
  line-height: 0px;
  max-height: 38px;
`;
